module.exports = __webpack_public_path__ + "img/icon-mnemonic.7c3d34fc.svg";